import PropTypes from 'prop-types';

export default function MaintenanceIcon(props) {
    const { className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            fill="none"
            viewBox="0 0 72 72"
            className={className}
        >
            <g clipPath="url(#clip0_5440_12202)">
                <path
                    fill="url(#paint0_linear_5440_12202)"
                    d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M38.76 32.253v-17.4a2.76 2.76 0 0 0-5.52 0v17.4a2.76 2.76 0 0 0 5.52 0M59.907 36A23.905 23.905 0 1 1 23.903 15.38a2.794 2.794 0 0 1 4.206 2.407c0 1.084-.424 1.958-1.371 2.518A18.26 18.26 0 0 0 17.778 36c0 10.049 8.175 18.223 18.222 18.223S54.224 46.05 54.224 36a18.26 18.26 0 0 0-8.96-15.696 2.73 2.73 0 0 1-1.372-2.402c0-1.098.438-1.984 1.405-2.539a2.73 2.73 0 0 1 2.8.016A23.95 23.95 0 0 1 59.908 36"
                    clipRule="evenodd"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_5440_12202"
                    x1="36"
                    x2="36"
                    y1="0"
                    y2="72"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8932"></stop>
                    <stop offset="0.5" stopColor="#FD6F8F"></stop>
                    <stop offset="1" stopColor="#BB1DB3"></stop>
                </linearGradient>
                <clipPath id="clip0_5440_12202">
                    <path fill="#fff" d="M0 0h72v72H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

MaintenanceIcon.propTypes = {
    className: PropTypes.string,
};
